import React, { useEffect, useState } from "react"
import { Row, Col, Card, CardBody, CardTitle, InputGroup, Label, FormGroup, Button } from "reactstrap"
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css"
import Flatpickr from "react-flatpickr"
import Select from "react-select"
import { connect } from "react-redux"
import * as url from "../../helpers/url_helper"
import { setBreadcrumbItems } from "../../store/actions"
import moment from "moment"
import { BarLoader } from "react-spinners"

const AgenceReport = (props) => {
  document.title = "Rapport par agence | UE DIGITAL"

  const userJson = JSON.parse(localStorage.getItem("user"))

  const breadcrumbItems = [
    { title: "ueDigital", link: "/dashboard" },
    { title: "Rapports", link: "#" },
    { title: "Rapport par agence", link: "#" },
  ]

  const optionType = [{ options: [
    { label: "Tout", value: "" },
    { label: "COLIS", value: "COLIS" },
    { label: "BAGAGE", value: "BAGAGE" },
  ]}]

  const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"))
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"))
  const [agences, setAgences] = useState([])
  const [selectedAgence, setSelectedAgence] = useState(null)
  const [selectedType, setSelectedType] = useState(null)
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)

  const optionGroup = [{ options: agences }]

  const handleStartDate = (date) => setStartDate(moment(date[0]).format("YYYY-MM-DD"))
  const handleEndDate = (date) => setEndDate(moment(date[0]).format("YYYY-MM-DD"))

  const loadAgences = () => {
    const agencesArray = [{ label: "Toutes les agences", value: "" }]
    fetch(`${url.BACKEND_URL}/agence?etp=${userJson.usAgence.agEtp.etpId}&size=100`, {
      method: "GET", headers: { Accept: "application/json", "Content-Type": "application/json" },
    })
      .then((r) => r.json())
      .then((responseJson) => {
        if (responseJson.status === 200) {
          setAgences([
            ...agencesArray,
            ...responseJson.data.map((item) => ({ label: item.agNom, value: item.agId })),
          ])
        }
      })
      .catch(() => {})
  }

  const loadReport = () => {
    setLoading(true)
    const params = `start=${startDate}&end=${endDate}&etp=${userJson.usAgence.agEtp.etpId}&agence=${selectedAgence ? selectedAgence.value : ""}&type=${selectedType ? selectedType.value : ""}`
    fetch(`${url.HISTORY_URL}${url.AGENCE_REPORT}?${params}`, {
      method: "GET", headers: { Accept: "application/json", "Content-Type": "application/json" },
    })
      .then((r) => r.json())
      .then((responseJson) => {
        setLoading(false)
        if (responseJson.status === 200) {
          setData(Array.isArray(responseJson.data) ? responseJson.data : [])
        }
      })
      .catch(() => setLoading(false))
  }

  useEffect(() => {
    props.setBreadcrumbItems("Rapport par agence", breadcrumbItems)
    loadAgences()
    loadReport()
  }, [])

  return (
    <React.Fragment>
      <Row>
        <Col xl="2">
          <FormGroup className="mb-4">
            <Label>Début</Label>
            <InputGroup>
              <Flatpickr
                className="form-control d-block"
                placeholder="Date début"
                value={startDate}
                onChange={handleStartDate}
                options={{ altInput: true, altFormat: "Y-m-d", dateFormat: "Y-m-d" }}
              />
            </InputGroup>
          </FormGroup>
        </Col>
        <Col xl="2">
          <FormGroup className="mb-4">
            <Label>Fin</Label>
            <InputGroup>
              <Flatpickr
                className="form-control d-block"
                placeholder="Date fin"
                value={endDate}
                onChange={handleEndDate}
                options={{ altInput: true, altFormat: "Y-m-d", dateFormat: "Y-m-d" }}
              />
            </InputGroup>
          </FormGroup>
        </Col>
        <Col lg="3">
          <div className="mb-3">
            <Label>Agence</Label>
            <Select
              value={selectedAgence}
              onChange={setSelectedAgence}
              options={optionGroup}
              classNamePrefix="select2-selection"
            />
          </div>
        </Col>
        <Col lg="2">
          <div className="mb-3">
            <Label>Type</Label>
            <Select
              value={selectedType}
              onChange={setSelectedType}
              options={optionType}
              classNamePrefix="select2-selection"
            />
          </div>
        </Col>
        <Col lg="3">
          <div className="mt-3">
            <Button
              type="button"
              style={{ width: "100%" }}
              onClick={loadReport}
              color="primary"
              size="lg"
              className="mt-2 waves-effect waves-light"
            >
              Rechercher
            </Button>
          </div>
        </Col>
      </Row>

      <Row>
        <Col>
          <Card>
            <CardBody>
              <CardTitle className="h4">{data.length} agence(s)</CardTitle>
              {loading ? <BarLoader width="100%" height={6} /> : null}
              <div className="table-rep-plugin">
                <div className="table-responsive mb-0" data-pattern="priority-columns">
                  <Table id="agence-report-table" className="table table-striped table-bordered">
                    <Thead>
                      <Tr>
                        <Th>#</Th>
                        <Th>Agence</Th>
                        <Th>Transactions</Th>
                        <Th>Frais total (FCFA)</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {data.map((item, key) => (
                        <Tr key={key}>
                          <Td>{key + 1}</Td>
                          <Th><strong>{item.agNom}</strong></Th>
                          <Td>{item.cpt}</Td>
                          <Td>{item.sumFrais.toLocaleString("fr-FR")}</Td>
                        </Tr>
                      ))}
                      {data.length > 0 && (
                        <Tr>
                          <Td></Td>
                          <Th><strong>TOTAL</strong></Th>
                          <Th><strong>{data.reduce((s, i) => s + i.cpt, 0)}</strong></Th>
                          <Th><strong>{data.reduce((s, i) => s + i.sumFrais, 0).toLocaleString("fr-FR")}</strong></Th>
                        </Tr>
                      )}
                    </Tbody>
                  </Table>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default connect(null, { setBreadcrumbItems })(AgenceReport)
